import React, { useEffect, useState } from "react";
import withRouter from "components/Common/withRouter";
import { useDispatch, useSelector } from "react-redux";
import {
  getPagerdutyServices as onGetPagerdutyServices,
  updatePagerdutyBluejayTeam as onUpdatePagerdutyBluejayTeam,
    getPagerdutyRefresh
} from "../../store/pagerduty/actions";
import {
  getBluejayTeam as onGetBluejayTeam,
} from "../../store/actions"
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Button,
  Container,
  Card,
  CardBody,
  Col,
  Row,
  Table,
} from "reactstrap";
import DocsTooltip from "components/Common/DocsTooltip";
import PropTypes from "prop-types";
import { team_values as TEAM_VALUES } from "../../constants/data_types";
import Loader from "../../components/Loader/Loader";
import refreshResourcesLottie from "../../assets/images/refresh_resources_lottie.json";

const Pagerduty = props => {
  const dispatch = useDispatch();

  const { pagerduty_services } = useSelector(state => ({
    pagerduty_services: state.PagerdutyServices.pagerduty_services,
  }));

  const [teams, setTeams] = useState([])
  const [pagerdutyRefreshModal, setPagerdutyRefreshModal] = useState(false);
  const [tooltip, setTooltip] = useState(false);

  useEffect(() => {
    dispatch(onGetBluejayTeam());
  }, [onGetBluejayTeam])

  const { bluejayTeams } = useSelector(state => ({
    bluejayTeams: state.Organization.bluejay_teams || []
  }))

  useEffect(() => {
    setTeams(bluejayTeams)
  }, [bluejayTeams])

  useEffect(() => {
    dispatch(onGetPagerdutyServices());
  }, [onGetPagerdutyServices]);

  const handleClick = () => {
    dispatch(getPagerdutyRefresh());
    setPagerdutyRefreshModal(true);
    setTimeout(() => {
        setPagerdutyRefreshModal(false);
    }, 3000);
  }

  const handleFormChange = (index, event, service) => {
    //Ignore the default value
    if (event.target.value === "") {
      return;
    }

    if (event.target.value === service?.bluejay_team?.id) {
      return;
    }

    const team_id = event.target.value
    const payload = {
      team_id: team_id,
      service_id: service.id
    }
    dispatch(onUpdatePagerdutyBluejayTeam(payload))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container>
          <Row>
            <Col lg="8">
              <div className="d-flex gap-1 align-items-start">
                <Breadcrumbs
                  title={"Pagerduty services"}
                  breadcrumbItem={"Pagerduty services"}
                />
                <span>
                  <i role="button" className="bx bx-help-circle font-size-18 text-white" id='externalTooltip2'/>
                </span>
              </div>
              <DocsTooltip 
                placement={'right'}
                isOpen={tooltip}
                toggle={() => setTooltip(!tooltip)}
                targetId={'externalTooltip2'}
                linkText={'External notifications?'}
                content={'Need help with'}
                link='https://docs.temperstack.com/temperstack/getting-started/integrations-hub/external-notifications'
              />
            </Col>
            <Col lg="4">
                <Button onClick={handleClick} color="primary" className="float-end">Rescan Pagerduty</Button>
            </Col>
          </Row>
          <Row>
          
                <div className="table-card">
                  <Table hover className="table-purple">
                    <thead className="table-light table-nowrap">
                      <tr>
                        <th>Name</th>
                        <th>Pagerduty ID</th>
                        <th>Created At</th>
                        <th>Refreshed At</th>
                        <th>Team</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        pagerduty_services.map((pagerduty_service, index) => (
                          <tr key={index}>
                            <td>{pagerduty_service.name}</td>
                            <td>{pagerduty_service.reference_id}</td>
                            <td>{pagerduty_service.created_at}</td>
                            <td>{pagerduty_service.updated_at}</td>
                            <td>
                              <div className="input">
                                <select
                                  id="formrow-InputState"
                                  name="default_teams"
                                  className="custom_select"
                                  placeholder="Assign Team"
                                  value={pagerduty_service?.bluejay_team?.id || ''}
                                  onChange={event => handleFormChange(index, event, pagerduty_service)}
                                >
                                  <option className="custom_select" value="">Select a team</option>
                                  {
                                    teams.map((team, index) => (
                                      <option className="custom_selec" key={index} value={team.id}>{team.name}</option>
                                    ))
                                  }
                                  <option value={TEAM_VALUES.UNMAPPED}>Unmapped</option>

                                </select>
                              </div>
                             
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </Table>
                </div>
          </Row>
        </Container>
      </div>
      <Loader
          isOpen={pagerdutyRefreshModal}
          lottieJson={refreshResourcesLottie}
          messageHeader="Scanning Pagerduty"
          message="Please wait while we scan your Pagerduty for new services."
      />
    </React.Fragment>
  );
};

Pagerduty.propTypes = {
  t: PropTypes.any,
};

export default withRouter(Pagerduty);
